module.exports = __webpack_public_path__ + "static/media/great.81133a97.png";